module.exports = __webpack_public_path__ + "static/media/400128_02.9ec72428.png";